/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as queryString from "query-string";
import { useHistory } from "react-router-dom";
import { Box, theme, Text } from "@nordcloud/gnui";
import { UniversalWrap, BrickLoader, KpiWidgets } from "~/components";
import { useKpiWidgetData } from "~/components/KPI/hooks";
import { KpiType } from "~/constants";
import { ROUTES } from "~/routing/routes";

type Props = {
  businessContext?: string;
};

export function BusinessContextKpiWidget({ businessContext }: Props) {
  const { costAllocationCoverage, overallWaste, nonProdHours, loading, error } =
    useKpiWidgetData(businessContext);

  const history = useHistory();

  const handleClick = (kpiType: KpiType) => {
    const typeQuery = queryString.stringify({ kpiType });
    const businessContextQuery = queryString.stringify({ businessContext });
    history.push(
      `${ROUTES.finopsKpi.index}?${typeQuery}&${businessContextQuery}`
    );
  };

  return (
    <Box mb={theme.spacing.spacing04}>
      <Text weight="medium" mb={theme.spacing.spacing04}>
        KPIs
      </Text>
      <UniversalWrap
        loaderProps={{
          loading,
          Component: BrickLoader,
          viewBox: "0 0 10 1",
        }}
        errorProps={{
          error,
        }}
      >
        <KpiWidgets
          costAllocationCoverage={costAllocationCoverage}
          nonProdHours={nonProdHours}
          overallWaste={overallWaste}
          onClick={handleClick}
        />
      </UniversalWrap>
    </Box>
  );
}
